import React, { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { IPlayerItemProps } from "../../../types/IPlayerSearchResponse";
import highlightText from "../../../utils/highlightText";
import LabelText from "../../../ui/LabelText";
import SecondaryButton from "../../../ui/SecondaryButton";
import { useNavigate } from "react-router-dom";
import { useSidebar } from "../../../contexts/SidebarContext";
import { useSearch } from "../../../contexts/PlayerSearchContext";
import EyeIcon from "../../../assets/icons/EyeIcon.png";
import noImagePlayer from "../../../assets/icons/noImagePlayer.svg"
import { PlayerAvatar } from "../../../styled-components/PlayerCard.Styles";
import { usePlayerSearch } from "../../../contexts/SearchPlayersContext";
import BookmarkBorderIcon from "@mui/icons-material/BookmarkBorder";
import BookmarkIcon from "@mui/icons-material/Bookmark";

const PlayerItem: React.FC<IPlayerItemProps> = ({ item, searchText, onRemove, iconType , isForComparePlayerASrchtype , isForSwapPlayers , isForSimulation, onAddToShortlist, playerComparisonTableData }) => {

  const navigate = useNavigate();
  const { toggleSidebar, toggleDrawer } = useSidebar();
  const {
    setSearchData,
    setSearchText,
    setSeasonId,
    setPlayerId
  } = useSearch();
  const {setComparePlayerName , setComparePlayerImageUrl ,setComparePlayerId ,setIsPlayerSearchOpen} = usePlayerSearch()
  const [isHovered, setIsHovered] = useState(false);
  const [isShortlisted, setIsShortlisted] = useState(false);
  const handleRemove = () => {
    if (onRemove) onRemove(item);
  };

  const handleAddToShortlist = () => {
    if (onAddToShortlist) onAddToShortlist(item);
  };
useEffect(() => {
  if (playerComparisonTableData) {
    const isShortlisted = Boolean(playerComparisonTableData?.find(player => player.playerId === item.playerId));
    setIsShortlisted(isShortlisted);
  }

}, [playerComparisonTableData, item.playerId]);

  let iconComponent;

  switch (iconType) {
    case "remove":
      iconComponent = <CloseIcon className="cta-btn-icons" onClick={handleRemove} />;
      break;
    case "image":
      iconComponent = <>{item.playerClubURL && <img src={item.playerClubURL} alt={item.playerClub} className="player-image" />}</>;
      break;
    default:
      iconComponent = "";
      break;
  }

  const handleViewProfile = () => {
      const searchedItemFromStorage = localStorage.getItem("PlayerSearchItem");
      let existingItems = [];
      if (searchedItemFromStorage) {
        existingItems = JSON.parse(searchedItemFromStorage);
      }
      const itemExists = existingItems.some((existingItem: any) => existingItem?.playerId === item.playerId);
      if (!itemExists) {
        existingItems.push(item);
        const updatedItemsString = JSON.stringify(existingItems);
        localStorage.setItem("PlayerSearchItem", updatedItemsString);
      }
      if(isForComparePlayerASrchtype){
          setComparePlayerName(item?.shortName!)
          setComparePlayerImageUrl(item?.imageUrl!)
          setComparePlayerId(item?.playerId!)
          setIsPlayerSearchOpen(false)
      }
      // else{
      //   navigate(`/player/${item.playerId}`);
      // }
      if(!isForSimulation){
        toggleDrawer?.(false);
        // toggleSidebar?.(false);
        setSearchData?.([]);
      }
      setSearchText("");
      setSeasonId(0);
      setPlayerId(item.playerId);
  };



  return (
    <>
    {isForComparePlayerASrchtype ? (
    <div className="club-item" >
      {isForSimulation && onAddToShortlist ? (
        <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%'}}>
          <div style={{width: '45%', display: 'flex', flexDirection: 'column', justifyContent: 'center'}} onClick={() => handleViewProfile()}>
            {item?.shortName! && highlightText(item?.shortName!, searchText ? searchText! : "")}
            {item.playerClub && <LabelText className="player-team-text club-name">{item.playerClub}</LabelText>}
          </div>
          <div style={{width: '25%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
            <PlayerAvatar
              isClub={false}
              className="player-table-image"
              src={item.imageUrl ? item.imageUrl : undefined}
              backgroundImage={!item.imageUrl ? item.imageUrl : undefined}
              onDragStart={(e) => {e.dataTransfer.setData("playerId", item?.playerId.toString())}}
            />
          </div>
          <div style={{width: '30%', display: 'flex', justifyContent: 'flex-end', alignItems: 'center', cursor: 'pointer'}}
            onClick={(e: React.MouseEvent) => {
              e.stopPropagation();
              handleAddToShortlist();
            }}>
            {isShortlisted ? <BookmarkIcon /> : <BookmarkBorderIcon />}

          </div>
        </div>
      ) : (
        <>
          <div className="player-text-data" onClick={() => (handleViewProfile())}>
            {item?.shortName! && highlightText(item?.shortName!, searchText ? searchText! : "")} {/* Use highlightText */}
            {/* <LabelText className="player-team-text club-name">{item.playerClub}</LabelText> */}
          </div>
          <PlayerAvatar
            isClub={false}
            className="player-table-image"
            src={item.imageUrl ? item.imageUrl : undefined}
            backgroundImage={!item.imageUrl ? item.imageUrl : undefined}
            onDragStart={(e) => {e.dataTransfer.setData("playerId", item?.playerId.toString())}}
          />
        </>
      )}
    </div>
    ):(
       <div className="player-item">
            {isForSimulation && onAddToShortlist ? (
        <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%'}}>
          <div style={{width: '45%', display: 'flex', alignItems: 'center'}}>
            {highlightText(item.playerName?.split(" ")?.length === 2 ? item?.isEasternPlayer ? `${item?.familyName} ${item?.givenName}` : `${item?.givenName} ${item?.familyName}` : item?.playerName, searchText ? searchText : "")}
            <LabelText className="player-team-text club-name">{item.playerClub}</LabelText>
            <div className="view-player" onClick={() => handleViewProfile()}>
              <img src={EyeIcon} alt="view player" className="view-player-image" />
              <LabelText className="player-team-text">{"View Player"}</LabelText>
            </div>
          </div>
          <div style={{width: '25%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
            {iconComponent}
          </div>
          <div style={{width: '30%', display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer'}}
            onClick={(e: React.MouseEvent) => {
              e.stopPropagation();
              handleAddToShortlist();
            }}>
            {isShortlisted ? <BookmarkIcon /> : <BookmarkBorderIcon />}
          </div>
        </div>
      ) : (
        <>
          <div className="player-text-data">
            {highlightText(item.playerName?.split(" ")?.length === 2 ? item?.isEasternPlayer ? `${item?.familyName} ${item?.givenName}` : `${item?.givenName} ${item?.familyName}` : item?.playerName, searchText ? searchText : "")} {/* Use highlightText */}
            <LabelText className="player-team-text club-name">{item.playerClub}</LabelText>
            <div className="view-player" onClick={() => handleViewProfile()}>
              <img src={EyeIcon} alt="view player" className="view-player-image" />
              <LabelText className="player-team-text">{"View Player"}</LabelText>
            </div>
          </div>
          {iconComponent}
        </>
      )}
      </div>
    )}
    
    </>
  );
};

export default PlayerItem;
